export const DEFAULT_I18N_LANG = 'ca';

export const ENV = 'ENV';

export const ESTATS = [
  { nom: 'Esborrany', id: 'ESB' },
  { nom: 'Obsolet', id: 'OBS' },
  { nom: 'Publicat', id: 'PUB' }
];

export const CONTENT_TYPE = ['CAMPS', 'DOC', 'PDF'];
